import {routeTo} from '@/utils/router'

// Server-safe half of useAuthContent (content/user/authentication.tsx). Everything here must stay
// free of client imports -- server components import it for generateMetadata, so a single
// styled-jsx or createContext dependency anywhere in this module's graph breaks the build.
export const getAuthContent = () => ({
  successLoginByMagicLink: {
    metaTitle: 'authentication.login-by-magic-link-success-meta-title',
    title: 'authentication.login-by-magic-link-success-title',
    subtitle: 'authentication.login-by-magic-link-success-desc',
    redirectTitle: 'authentication.login-by-magic-link-success-redirect',
    invalidLinkTitle: 'authentication.login-by-magic-link-invalid-link-title',
    invalidLinkDesc: 'authentication.login-by-magic-link-invalid-link-desc',
    invalidLinkButtonHref: routeTo.home(),
    invalidLinkButtonText: 'button-back-to-homepage',
  },
  accountInitiation: {
    header: 'authentication.account-initiation-header',
    title: 'authentication.account-initiation-title',
    description: 'authentication.account-initiation-desc',
    buttonLabel: 'authentication.account-initiation-button',
    errorText: 'authentication.account-initiation-error',
  },
  successActivation: {
    metaTitle: 'authentication.account-activation-success-meta-title',
    title: 'authentication.account-activation-success-title',
    subtitle: 'authentication.account-activation-success-desc',
    redirectTitle: 'authentication.account-activation-success-redirect',
    invalidLinkTitle: 'authentication.account-activation-invalid-link-title',
    invalidLinkDesc: 'authentication.account-activation-invalid-link-desc',
    invalidLinkButtonHref: routeTo.home(),
    invalidLinkButtonText: 'button-back-to-homepage',
  },
  setPasswordTitle: 'authentication.set-password-title',
  forgottenPasswordTitle: 'authentication.forgot-password-title',
  successForgotPassword: {
    title: 'authentication.forgot-password-success-title',
    description: 'authentication.forgot-password-success-desc',
  },
})
